import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabPanelContainer } from 'app/common';
import { RolesTabPanel } from './RolesTabPanel';
import { ClientRolesTabPanel } from './ClientRolesTabPanel';
import { ReportsTabPanel } from './ReportsTabPanel';

export const UserMaintenanceTabContainer: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          marginBottom: '1em',
        }}
      >
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Client Roles" {...a11yProps(0)} />
          <Tab label="Roles" {...a11yProps(1)} />
          <Tab label="Reports" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <ClientRolesTabPanel value={value} index={0} />
      <RolesTabPanel value={value} index={1} />
      <ReportsTabPanel value={value} index={2} />
    </Box>
  );
};
